import Vue from 'vue';
import Router from 'vue-router';
import Auth from '@/Auth.vue';
import Website from '@/Website.vue';
import ActionHandler from '@/ActionHandler.vue';

Vue.use(Router);

export default function () {
	const router = new Router({
		mode: 'history',
		base: process.env.BASE_URL,
		linkActiveClass: 'active',
		routes: [
			{
				path: '',
				name: 'Dashboard',
				component: Auth,
				meta: {
					title: 'Auth',
				},
				props: {
					showDashboard: true,
					fromWebsite: false,
				},
			},
			{
				path: '/website',
				name: 'Website',
				// beforeEnter: (to, from, next) => (!to.params.id ? next('/rambox') : next()),
				component: Website,
				meta: {
					title: 'Auth',
				},
				children: [
					{
						path: '',
						name: 'Auth',
						components: { Auth },
					},
				],
			},
			{
				path: '/action',
				name: 'ActionHandler',
				component: ActionHandler,
				meta: {
					title: 'Rambox',
				},
			},
			{
				path: '/privacy',
				name: 'Privacy Policy',
				beforeEnter() {
					location.href = 'https://rambox.app/privacy/';
				},
			},
			{
				path: '/terms',
				name: 'Terms of use',
				beforeEnter() {
					location.href = 'https://rambox.app/terms/';
				},
			},
			{
				path: '/:id',
				name: 'Auth',
				// beforeEnter: (to, from, next) => (!to.params.id ? next('/rambox') : next()),
				component: Auth,
				meta: {
					title: 'Auth',
				},
			},
		],
	});

	router.beforeEach((to, from, next) => {
		if (to.matched.length === 0) return next({ name: 'Auth' });
		else next();
	});

	return router;
}
